<template>
  <v-container fluid>
    <v-row>
      <v-col class="pb-0">
        <v-tabs v-model="tabs" center-active fixed-tabs>
          <v-tab>상세정보</v-tab>
          <v-tab>고장정보</v-tab>
        </v-tabs>
      </v-col>
      <v-col class="pb-0" cols="12">
        <v-select
          solo
          outlined
          dense
          hide-details
          @change="changeSubComp"
          :items="comboList"
          v-model="select"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-row>
                <v-col>
                  <p class="pt-3">태양광 상세정보</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-simple-table fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center">총 누적발전량</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_TotalP}}
                            <span class="text-caption">MWh</span>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center">당월발전량</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_CurrentMonth_P}}
                            <span class="text-caption">MWh</span>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center">전월발전량</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_CurrentMonth_P}}
                            <span class="text-caption">MWh</span>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center">일간누적발전량</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_DailyP}}
                            <span class="text-caption">MWh</span>
                          </td>
                        </tr>
                        <tr v-show="false">
                          <th class="text-center">순간최대출력전력</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Pmax}}
                            <span class="text-caption">MWh</span>
                          </td>
                        </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col cols="12">
                  <v-simple-table fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center">인버터 출력전력</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Pac}}
                            <span class="text-caption">kW</span>
                          </td>
                        </tr>
                        <tr v-show="false">
                          <th class="text-center">인버터 동작상태</th>
                          <td class="text-center">{{PVPCS.PVPCS_STATUS1_NM}}</td>
                        </tr>
                        <tr>
                          <th class="text-center">일간 누적발전시간</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_DailyH}}
                            <span class="text-caption">h</span>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center">총누적발전시간</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_DailyP}}
                            <span class="text-caption">h</span>
                          </td>
                        </tr>
                        <tr v-show="false">
                          <th class="text-center">누적팬 운전일수</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_FanRunDay}}
                            <span class="text-caption">Days</span>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center">역률</th>
                          <td class="text-center">
                            {{PVPCS.PVPCS_PF}}
                            <span class="text-caption">%</span>
                          </td>
                        </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col cols="12">
                  <v-simple-table fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center" rowspan="3">선간전압</th>
                          <td class="text-center">R-S</td>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Vrs}}
                            <span class="text-caption">V</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">S-T</td>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Vst}}
                            <span class="text-caption">V</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">T-R</td>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Vtr}}
                            <span class="text-caption">V</span>
                          </td>
                        </tr>
                        <tr>
                          <th class="text-center" rowspan="3">전류</th>
                          <td class="text-center">R</td>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Ir}}
                            <span class="text-caption">A</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">S</td>
                          <td class="text-center">
                            {{PVPCS.PVPCS_Is}}
                            <span class="text-caption">A</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">T</td>
                          <td class="text-center">
                            {{PVPCS.PVPCS_It}}
                            <span class="text-caption">A</span>
                          </td>
                        </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-data-iterator
                :items="breakInfo"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:header>
                  <p>배터리 고장정보</p>
                  <p class="text-body-2">
                    고장정보 체크 시점일
                    <span class="pl-6 txt-blue">{{ nowDate }}</span>
                  </p>
                  <v-divider></v-divider>
                </template>
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="item in props.items"
                      :key="item.name"
                      cols="12"
                      sm="4"
                      md="3"
                      lg="2"
                    >
                      <v-card width="350" min-width="350" class="elevation-0">
                        <v-card-title class="text-subtitle-2">
                          <div
                            class="rounded-circle d-inline-block mr-10"
                            style="width: 25px; height: 25px; background: #d42a46"
                            v-if="item.condition"
                          ></div>
                          <div
                            class="rounded-circle d-inline-block mr-10"
                            style="width: 25px; height: 25px; background: #bdbdbd"
                            v-else
                          ></div>
                          {{item.title}}
                        </v-card-title>
                        <v-divider></v-divider>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import day from 'dayjs'
export default {
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      itemsPerPage: 50,
      select: '',
      nowDate: day().format('YYYY-MM-DD HH:mm:ss'),
      description: '',
      item: [],
      PVPCS: {
        PVPCS_FAULT1: '1.0'
      },
      essResult: []
    }
  },
  watch: {
    essData() {
      this.initData()
    },
    comboList() {
      this.select = this.comboList[0].value
    }
  },
  mounted: function() {
    this.initData()
  },
  computed: {
    comboList() {
      let list = []
      for (let item of this.essResult) {
        if (item.photo === 'PVPCS') {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      this.select = list[0]
      return list
    },
    breakInfo() {
      return [
        {
          title: '문열림. 비상정지',
          condition: this.PVPCS.PVPCS_FAULT1 === '1.0'
        },
        {
          title: 'AC 차단기(Q2) 상태',
          condition: this.PVPCS.PVPCS_FAULT1 === '2.0'
        },
        {
          title: 'DC 차단기(Q2) 상태',
          condition: this.PVPCS.PVPCS_FAULT1 === '4.0'
        },
        {
          title: 'U상 IGBT 이상',
          condition: this.PVPCS.PVPCS_FAULT1 === '8.0'
        },
        {
          title: 'V상 IGBT 이상',
          condition: this.PVPCS.PVPCS_FAULT1 === '16.0'
        },
        {
          title: 'W상 IGBT 이상',
          condition: this.PVPCS.PVPCS_FAULT1 === '32.0'
        },
        {
          title: '입력 과전압',
          condition: this.PVPCS.PVPCS_FAULT1 === '64.0'
        },
        {
          title: '입력 저전압',
          condition: this.PVPCS.PVPCS_FAULT1 === '128.0'
        },
        {
          title: '입력 과전류',
          condition: this.PVPCS.PVPCS_FAULT2 === '1.0'
        },
        {
          title: '출력 과전압',
          condition: this.PVPCS.PVPCS_FAULT2 === '2.0'
        },
        {
          title: '출력 저전압',
          condition: this.PVPCS.PVPCS_FAULT2 === '4.0'
        },
        {
          title: '출력 과전류',
          condition: this.PVPCS.PVPCS_FAULT2 === '8.0'
        },
        {
          title: '접촉기(K1) 이상',
          condition: this.PVPCS.PVPCS_FAULT2 === '16.0'
        },
        {
          title: '계통전류 불평형',
          condition: this.PVPCS.PVPCS_FAULT2 === '32.0'
        },
        {
          title: '파워소자 과온',
          condition: this.PVPCS.PVPCS_FAULT1 === '64.0'
        },
        {
          title: '단상 결상',
          condition: this.PVPCS.PVPCS_FAULT1 === '128.0'
        },
        {
          title: '입력 과전류',
          condition: this.PVPCS.PVPCS_FAULT2 === '1.0'
        },
        {
          title: '출력 과전압',
          condition: this.PVPCS.PVPCS_FAULT2 === '2.0'
        },
        {
          title: '출력 저전압',
          condition: this.PVPCS.PVPCS_FAULT2 === '4.0'
        },
        {
          title: '출력 과전류',
          condition: this.PVPCS.PVPCS_FAULT2 === '8.0'
        },
        {
          title: '접촉기(K1) 이상',
          condition: this.PVPCS.PVPCS_FAULT2 === '16.0'
        },
        {
          title: '계통전류 불평형',
          condition: this.PVPCS.PVPCS_FAULT2 === '32.0'
        },
        {
          title: '파워소자 과온',
          condition: this.PVPCS.PVPCS_FAULT1 === '64.0'
        },
        {
          title: '단상 결상',
          condition: this.PVPCS.PVPCS_FAULT1 === '128.0'
        },
        {
          title: '리액터 과온',
          condition: this.PVPCS.PVPCS_FAULT1 === '1.0'
        },
        {
          title: '변압기 과온',
          condition: this.PVPCS.PVPCS_FAULT1 === '2.0'
        },
        {
          title: '계통 과주파수',
          condition: this.PVPCS.PVPCS_FAULT1 === '4.0'
        },
        {
          title: '계통 저주파수',
          condition: this.PVPCS.PVPCS_FAULT1 === '8.0'
        },
        {
          title: 'DC 입력 측 서지어레스트',
          condition: this.PVPCS.PVPCS_FAULT1 === '16.0'
        },
        {
          title: 'AC 출력 측 서지 어레스트',
          condition: this.PVPCS.PVPCS_FAULT1 === '32.0'
        },
        {
          title: 'Passive Anti-IsLanding for JP',
          condition: this.PVPCS.PVPCS_FAULT1 === '64.0'
        },
        {
          title: 'Active Anti-Islanding for JP',
          condition: this.PVPCS.PVPCS_FAULT1 === '128.0'
        }
      ]
    }
  },
  methods: {
    initData() {
      if (this.essData.result !== 'noData') {
        this.item = this.essData
        this.essResult = this.item.essResult
        this.description = this.essResult.filter(
          d => d.codenm === 'PVPCS01'
        )[0].description

        if (this.item.essData.filter(d => d.PVPCS).length !== 0) {
          this.PVPCS = this.item.essData.filter(d => d.PVPCS)[0].PVPCS
        }
      }
    },
    changeSubComp(e) {
      let codeID = e.target.value
      this.description = e.target.desc
      this.PVPCS = this.item.essData
        .filter(d => d.PVPCS)
        .filter(d => d.PVPCS.PVPCS_CODEID === codeID)[0].PVPCS
    },
    changeTab(key) {
      $("span[name='sub_tab_pcs']").removeClass('on')
      $('#tab_pcs_' + key).addClass('on')

      $("div[name='pcs_tab']").removeClass('on')
      $('#pcs_' + key).addClass('on')
    }
  }
}
</script>

<style lang="less" scoped>
.txt-blue {
  color: var(--v-txtblue-base);
}
.v-data-table__wrapper > table > thead > tr > td {
  border: 1px solid var(--v-borderColor-base);
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  border: 1px solid var(--v-borderColor-base);
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border: 1px solid var(--v-borderColor-base);
}
</style>
